import { defineStore } from 'pinia';

import { getUpList } from '@/api/seller/upload-record';

interface UploadRecordState {
  platformId: number | ''
  createTime: string
  goodsSn: string
}

export const useUploadRecords = defineStore({
  id: 'seller-upload-records',
  state: (): UploadRecordState => ({
    platformId: '',
    createTime: '',
    goodsSn: '',
  }),
  getters: {},
  actions: {
    async getUploadRecords(page: number, limit: string) {
      return getUpList({
        pt_id: this.platformId,
        page,
        limit,
        create_time: this.createTime,
        goods_sn: this.goodsSn,
      });
    },
  },
});
